import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowRight
} from '@fortawesome/free-solid-svg-icons';

const icons = {
  rightArrow: faArrowRight
};

function Icons({ icon, ...rest }) {
  return <FontAwesomeIcon icon={icons[icon]} {...rest} />;
}

Icons.propTypes = {
  icon: PropTypes.string.isRequired,
};

export default Icons;
